import React from 'react'
import { LandingPageImport } from '../Import'
const { TextAnimate, ImageAnimate, Button, Card, Clock4, GitCommitHorizontal, MapPin, hero_img_1, hero_img_2 } = LandingPageImport

export default function HeroSection() {
    return (
        <>
            <div className='hero_section'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className='hero_title'>
                                <h5 data-aos="fade-left" data-aos-duration="800">
                                    <GitCommitHorizontal className='ms-1 me-1' />
                                    Anytime Anywhere Any Distance
                                </h5>
                            </div>

                            <div className="hero_sub_title">
                                <h1>
                                    <TextAnimate text="Walk, Run, Ride in Celebration" />
                                </h1>

                                <p data-aos="fade-left" data-aos-duration="900">
                                    As we conclude another incredible season of Walk Run Ride InCelebration, I want to extend my deepest gratitude to each and everyone of you. Your enthusiasm, dedication, and spirit have made thisevent truly special. Whether you walked, ran, or rode, yourparticipation has not only celebrated health and wellness but alsofostered a sense of community and togetherness.
                                </p>

                                <Button
                                    type='button'
                                    size='sm'
                                    className='common_btn mt-3'
                                    data-aos="fade-left" data-aos-duration="1000"
                                >
                                    Reserve My Seat
                                </Button>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <Card className='floating_card hero_img aniamtion-key-1 p-3' style={{ width: '18rem' }}>
                                <Card.Img variant="top" src={hero_img_1} />
                                <Card.Body>
                                    <Card.Title>13 Oct, 2025</Card.Title>
                                    <Card.Text>
                                        <Clock4 size={20} /><span className='ms-1 me-1'>10:00 AM - 12:00 PM</span><br />
                                        <MapPin size={20} /><span className='ms-1 me-1'>P-101, Vijay Nagar, Indore</span>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </div>
                        <div className="col-lg-5">
                            <div className="text-center">
                                <div className='hero_img'>
                                    <div className="text-center">
                                        <ImageAnimate src={hero_img_2} alt="img" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}